import {useApp} from '../../../contexts/AppContext';
import {useAuth} from '../../../contexts/UserContext';
import {useEffect, useState, useRef} from 'react';
import {
  getScannedDeviceInfoWithAuth,
  addNewRoom,
  changeDeviceRoom,
  changeDeviceSerialCode,
  deleteDevice,
  addDevice,
} from '../../../api';
import {
  PageTopVenueName,
} from '../../organisms/CommonParts';
import {
  SectionTitle,
  SubInner,
  TabHeader,
  InputLabel,
  FormInput,
} from '../../atoms/CommonParts';
import styled from 'styled-components';
import config from '../../../config';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import moment from 'moment';
import SelectModal, {SelectedLabel} from '../../organisms/SelectModal';
import {
  useCustomDialog,
  ButtonLayout,
} from '../../../contexts/CustomDialogContext';

const Page = styled.div`
  @media ${config.layout.wide} {
  }
`;

const NewDeviceSection = styled.div`
  margin-bottom: 30px;
`;

const NewDeviceBlock = styled.div`
  border: 1px solid #000000;
  border-radius: 2px;
  padding: 20px 20px 30px;
`;

const NewDeviceRoomLabel = styled.div`
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 21px;
  font-weight: bold;
`;

const NewDeviceModelArea = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

const NewDeviceModelAreaLabel = styled.span`
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
`;

const NewDeviceModelAreaValue = styled.span`
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  display: block;
  margin-top: 10px;

  &.error {
    color: #FF7323;
  }
`;

const NewDeviceRegisterButton = styled.button``;

const ScannedDeviceSection = styled.div``;

const ScannedDeviceBlock = styled.div`
  border: 4px solid #5f5f5f;
  border-radius: 4px;
  background-color: #fff;
  margin-bottom: 30px;
  padding: 0 20px 30px;
`;

const ScannedDeviceBlockTitle = styled.div`
  text-align: center;
  border-bottom: 1px solid #000000;
  font-size: 16px;
  font-weight: bold;
  line-height: 60px;
  height: 60px;
`;

const ScannedDeviceRegisterButton = styled.button`
  margin-top: 30px !important;
  margin-bottom: 0px !important;
`;

const TopSectionTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: 32px;
  margin-top: 40px;
  margin-bottom: 20px;
  @media ${config.layout.wide} {
    margin-top: 30px;
  }
`;

const RegisteredDevicesTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: 21px;
  margin-top: 40px;
  margin-bottom: 20px;
`;

const RegisteredDeviceBlock = styled.div`
  border-radius: 2px;
  position: relative;
  padding: 20px 20px 30px;
  border: 1px solid #000000;
  margin-bottom: 30px;
`;

const RemoveDeviceButton = styled.button`
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  padding: 0 13px !important;
  position: absolute;
  right: 10px;
  top: 10px;
`;

const AddedOnLabel = styled.div`
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;
`;

const RegisteredDeviceDataArea = styled.div`
  height: 170px;
  display: flex;
  margin-top: 24px;
  justify-content: space-between;
`;

const RegisteredDeviceImageArea = styled.div`
  width: 40.6%;
  height: 100%;
  flex: 0 2 auto;
  background-color: #F8F8F8;
  background-size: 130px auto;
  background-position: center;
  background-repeat: no-repeat;
  @media ${config.layout.wide} {
    width: 34.8%;
  }
`;

const RegisteredDeviceInfoArea = styled.div`
  width: 59.4%;
  height: 100%;
  flex: 1 1 auto;
  padding: 0 0 0 20px;

  @media ${config.layout.wide} {
    width: 65.2%;
  }
`;

const RegisteredDeviceInfo = styled.div`
  h4 {
    font-size: 12px;
    line-height: 16px;
    font-weight: bold;
    white-space: nowrap;
  }

  span {
    display: block;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    margin-top: 4px;
    margin-bottom: 13px;
    white-space: nowrap;
  }
`;

const RegisteredDeviceChangeButton = styled.button`
  padding: 0 0 !important;
  width: 88px;
  text-align: center;
`;

const RegisteredDevieRoomDropdownWrap = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 20px;

  & > * {
    flex: 0 0 auto;

    &:first-child {
      width: 50%;
      flex: 2 0 auto;
    }
  }
`;

const SerialNumberInfo = styled.div`
  font-size: 14px;
  @media ${config.layout.wide} {
    font-size: 16px;
  }
`;

const RegisteredDevieRoomEditToggle = styled.div`
  user-select: none;
  height: 60px;
  font-size: 14px;
  line-height: 60px;
  font-weight: bold;
  text-align: center;
  border-top: 1px solid #000000;
  border-bottom: 1px solid #000000;
  position: relative;

  &.new {
    margin-top: 20px;
  }

  &.open {
    &:after {
      transform: rotateZ(180deg);
    }

    border-bottom-color: transparent;
  }

  transition: background-color 0.15s linear, color 0.15s linear;
  cursor: pointer;
  @media ${config.layout.wide} {
    &:hover {
      background-color: #000000;
      color: #ffffff;
    }
  }

  &:after {
    content: "";
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath id='_' data-name='&lt;' d='M1.555,5,6,.744,5.223,0,0,5l5.223,5L6,9.256Z' transform='translate(0 6) rotate(-90)' fill='%23000000'/%3E%3C/svg%3E");
    position: absolute;
    display: block;
    width: 10px;
    height: 6px;
    right: 10px;
    top: 50%;
    margin-top: -3px;
    transform: rotateZ(0);
    transition: transform 0.15s ease-out;
  }
`;

const RegisteredDevieRoomEditContent = styled.div`
  display: none;

  &.open {
    display: block;

    &.new {
      padding-bottom: 10px;
      border-bottom: 1px solid #000000;
    }
  }
`;

const RegisteredDevieRoomEditItem = styled.div`
  margin-top: 10px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 20px;
  height: 46px;

  & > * {
    flex: 0 0 auto;

    &:first-child {
      width: 50%;
      flex: 2 0 auto;
    }
  }
`;

const RegisteredDevieRoomAddButton = styled.button`
  padding: 0 0 !important;
  width: 88px;
  text-align: center;
`;

const KUVOCareArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 28px;

  button {
    width: 164px;
  }
`;

function NewDevice({device, setDevice}) {
  const auth = useAuth();
  const [editIsOpen, setEditIsOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const rooms = auth.state.rooms || [];
  const {customDialog, errorDialogWithAPIError, okDialog} = useCustomDialog();
  const [model, setModel] = useState({
    error: !device.valid && device.customer_id.length == 15,
    name: (device.valid && device.device_name) || '',
  });
  const location = useLocation();
  const navigate = useNavigate();

  let selectedIndex = -1;
  let r = rooms.find((_r, i) => {
    if (_r.room_id == device.room_id) {
      selectedIndex = i;
      return true;
    }
    return false;
  });
  if (selectedIndex < 0) {
    selectedIndex = 0;
    r = rooms[0];
  }

  const onClickDropdown = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const itemSelect = (index) => {
    setModalIsOpen(false);
    setDevice({
      ...device,
      room_id: rooms[index].room_id,
    });
  };

  const handleRoomAddSubmit = (event) => {
    event.preventDefault();
    let form = event.currentTarget;
    let formData = new FormData(form);
    let name = (formData.get('name') || '').trim().substr(0, 256);
    if (!name) {
      (async function() {
        await customDialog({
          buttons: ButtonLayout.None,
          description_element: (
              <ul>
                <li>- Room/floor is required</li>
              </ul>
          ),
        });
      })();
      return;
    }
    if (rooms.some((r) => r.name.toUpperCase() == name.toUpperCase())) {
      (async function() {
        await customDialog({
          buttons: ButtonLayout.None,
          description_element: (
              <ul>
                <li>- The floor/room name already exists.</li>
              </ul>
          ),
        });
      })();
      return;
    }

    (async () => {
      window.incrementLoading();
      try {
        let {room, rooms} = await addNewRoom({
          name,
        });
        form.reset();
        setDevice({
          ...device,
          room_id: room.room_id,
        });
        auth.dispatch({
          type: 'set_rooms',
          rooms,
        });

        window.decrementLoading();
      } catch (e) {
        window.decrementLoading();
        console.error(e);
        await errorDialogWithAPIError(e);
      }
    })();
  };

  const isValidSerialCode = (code) => {
    return !code || /^[0-9a-z]{12}$/i.test(code);
  };

  const validateSerialCode = (event) => {
    let value = event.target.value.trim().toUpperCase();
    if (device.serial_code == value) {
      return;
    }
    setDevice({
      ...device,
      serial_code: value,
    });
  };

  const validateCustomerID = (event) => {
    let value = event.target.value.trim().toUpperCase();
    if (device.customer_id == value) {
      return;
    }

    if (/^[0-9a-f]{15}$/gi.test(value)) {
      (async function(value) {
        let validatedDevice = null;
        window.isValidating = true;
        try {
          validatedDevice = await getScannedDeviceInfoWithAuth({
            customer_id: value,
          });
          console.log(validatedDevice);
        } catch (e) {
          validatedDevice = null;
        }
        window.isValidating = false;
        console.log(validatedDevice);
        if (validatedDevice && validatedDevice.device_name) {
          setModel({
            error: false,
            name: validatedDevice.device_name,
          });
          setDevice({
            ...device,
            customer_id: value,
            device_name: validatedDevice.device_name,
            scanned: false,
            valid: true,
            is_others: validatedDevice.is_others,
            is_ours: validatedDevice.is_ours,
          });
        } else {
          setModel({
            error: true,
            name: '',
          });
          setDevice({
            ...device,
            customer_id: value,
            device_name: '',
            scanned: false,
            valid: false,
            is_others: false,
            is_ours: false,
          });
        }
      })(value);
      return;
    } else if (value.length >= 15) {
      setModel({
        error: true,
        name: '',
      });
      setDevice({
        ...device,
        customer_id: value,
        device_name: '',
        scanned: false,
        valid: false,
        is_others: false,
        is_ours: false,
      });
    } else {
      setModel({
        error: false,
        name: '',
      });
      setDevice({
        ...device,
        customer_id: value,
        device_name: '',
        scanned: false,
        valid: false,
        is_others: false,
        is_ours: false,
      });
    }
  };

  async function handleSubmitCore() {

    if (device.is_ours) {
      await okDialog({
        description_element: <span>This device is already registered.</span>,
      });
      return;
    }
    if (device.is_others) {
      let confirm = await customDialog({
        description_element: (
            <span>
            This device is registered at another venue. <br className="pc"/>
            Do you want to switch it to your account?
          </span>
        ),
        buttons: [
          {
            label: 'No, cancel',
            positive: false,
          },
          {
            label: 'Yes',
            positive: true,
          },
        ],
      });
      if (confirm != 1) {
        return;
      }
    }

    window.incrementLoading();
    try {
      await addDevice({
        customer_id: device.customer_id,
        room_id: device.room_id,
        serial_code: device.serial_code,
      });
      window.decrementLoading();
      await okDialog({
        description_element:
            <span>Your device has been registered successfully.</span>,
      });
      if (location.search) {
        window.location.href = window.location.pathname;
        navigate(location.pathname);
      } else {
        window.location.reload();
      }
    } catch (e) {
      window.decrementLoading();
      console.error(e);
      await errorDialogWithAPIError(e);
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (window.isValidating || !device.valid ||
        !isValidSerialCode(device.serial_code)) {
      return;
    }
    handleSubmitCore();
  }

  return (
      <NewDeviceSection>
        <TopSectionTitle>New Registration</TopSectionTitle>
        <NewDeviceBlock>
          <NewDeviceRoomLabel>Room/Floor</NewDeviceRoomLabel>

          <SelectedLabel onClick={onClickDropdown}>{r.name}</SelectedLabel>
          <SelectModal
              title="Room/Floor"
              candidates={rooms.map((c) => c.name)}
              selectedIndex={selectedIndex}
              closeModal={closeModal}
              modalIsOpen={modalIsOpen}
              itemSelect={itemSelect}
          />
          <RegisteredDevieRoomEditToggle
              onClick={() => {
                setEditIsOpen(!editIsOpen);
              }}
              className={editIsOpen
                  ? 'open new room-edit-toggle'
                  : 'closed new room-edit-toggle'}
          >
            Add another room/floor
          </RegisteredDevieRoomEditToggle>
          <RegisteredDevieRoomEditContent
              className={editIsOpen ? 'open new' : 'closed new'}
          >
            <form onSubmit={handleRoomAddSubmit}>
              <RegisteredDevieRoomEditItem>
                <FormInput type="text" required name="name"/>
                <RegisteredDevieRoomAddButton
                    type="submit"
                    className="dark-button"
                >
                  <span>Add</span>
                </RegisteredDevieRoomAddButton>
              </RegisteredDevieRoomEditItem>
            </form>
          </RegisteredDevieRoomEditContent>
          <form onSubmit={handleSubmit}>

            <NewDeviceModelArea>
              <NewDeviceModelAreaLabel>Device model</NewDeviceModelAreaLabel>
              {model.error ? (
                  <NewDeviceModelAreaValue className="error">
                    Invalid KUVO Device ID
                  </NewDeviceModelAreaValue>
              ) : (
                  <NewDeviceModelAreaValue>
                    {model.name || '- - - - - - - - - - - - - -'}
                  </NewDeviceModelAreaValue>
              )}
            </NewDeviceModelArea>

            <LabelWithInfo
                text={'KUVO Device ID'}
                labelclassname="room-field-label"
                style={{
                  marginTop: 20,
                  marginBottom: 19,
                }}
            >
              <div>
                KUVO Device ID is fifteen digits of numbers and alphabets
                implemented
                per device.
              </div>
            </LabelWithInfo>
            <FormInput
                type="text"
                required
                name="customer_id"
                defaultValue={device.customer_id}
                onBlur={validateCustomerID}
                onChange={validateCustomerID}
                maxLength={15}
            />

            <LabelWithInfo
                text={'Serial no.'}
                labelclassname="room-field-label"
                style={{
                  marginTop: 21,
                  marginBottom: 19,
                }}
            >
              <SerialNumberInfo>
                A serial number is a unique twelve-digit per device displayed on
                the side or the bottom of the device.
                (e.g. AAAA000000AA)<br/>
                [CDJ-3000] [CDJ-3000X] You can preset it by scanning the QR code from the
                setting menu.
              </SerialNumberInfo>
            </LabelWithInfo>
            <FormInput
                type="text"
                name="serial_code"
                defaultValue={device.serial_code}
                maxLength={12}
                pattern={'^[0-9a-zA-Z]{12}$'}
                onBlur={validateSerialCode}
                onChange={validateSerialCode}
            />

            <NewDeviceRegisterButton
                className={`dark-button center-fixed primary ${
                    device.valid && isValidSerialCode(device.serial_code)
                        ? ''
                        : 'disabled'
                }`}
                type="submit"
                disabled={!(device.valid &&
                    isValidSerialCode(device.serial_code))}
                style={{
                  marginTop: 30,
                }}
            >
              <span>Register</span>
            </NewDeviceRegisterButton>
          </form>
        </NewDeviceBlock>
      </NewDeviceSection>
  );
}

function ScannedDevice({device, setDevice}) {
  const auth = useAuth();
  const [editIsOpen, setEditIsOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const rooms = auth.state.rooms || [];
  const {customDialog, errorDialogWithAPIError, okDialog} = useCustomDialog();
  const location = useLocation();
  const navigate = useNavigate();

  let selectedIndex = -1;
  let r = rooms.find((_r, i) => {
    if (_r.room_id == device.room_id) {
      selectedIndex = i;
      return true;
    }
    return false;
  });
  if (selectedIndex < 0) {
    selectedIndex = 0;
    r = rooms[0];
  }

  const onClickDropdown = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const itemSelect = (index) => {
    setModalIsOpen(false);
    setDevice({
      ...device,
      room_id: rooms[index].room_id,
    });
  };

  const handleRoomAddSubmit = (event) => {
    event.preventDefault();
    let form = event.currentTarget;
    let formData = new FormData(form);
    let name = (formData.get('name') || '').trim().substr(0, 256);
    if (!name) {
      (async function() {
        await customDialog({
          buttons: ButtonLayout.None,
          description_element: (
              <ul>
                <li>- Room/floor is required</li>
              </ul>
          ),
        });
      })();
      return;
    }
    if (rooms.some((r) => r.name.toUpperCase() == name.toUpperCase())) {
      (async function() {
        await customDialog({
          buttons: ButtonLayout.None,
          description_element: (
              <ul>
                <li>- The floor/room name already exists.</li>
              </ul>
          ),
        });
      })();
      return;
    }

    (async () => {
      window.incrementLoading();
      try {
        let {room, rooms} = await addNewRoom({
          name,
        });
        form.reset();
        setDevice({
          ...device,
          room_id: room.room_id,
        });
        auth.dispatch({
          type: 'set_rooms',
          rooms,
        });

        window.decrementLoading();
      } catch (e) {
        window.decrementLoading();
        console.error(e);
        await errorDialogWithAPIError(e);
      }
    })();
  };

  async function handleSubmitCore() {
    if (device.is_ours) {
      await okDialog({
        description_element: <span>This device is already registered.</span>,
      });
      return;
    }
    if (device.is_others) {
      let confirm = await customDialog({
        description_element: (
            <span>
            This device is registered at another venue. <br className="pc"/>
            Do you want to switch it to your account?
          </span>
        ),
        buttons: [
          {
            label: 'No, cancel',
            positive: false,
          },
          {
            label: 'Yes',
            positive: true,
          },
        ],
      });
      if (confirm != 1) {
        return;
      }
    }

    window.incrementLoading();
    try {
      await addDevice({
        customer_id: device.customer_id,
        room_id: device.room_id,
        serial_code: device.serial_code,
      });
      window.decrementLoading();
      await okDialog({
        description_element:
            <span>Your device has been registered successfully.</span>,
      });
      if (location.search) {
        window.location.href = window.location.pathname;
      } else {
        window.location.reload();
      }
    } catch (e) {
      window.decrementLoading();
      console.error(e);
      await errorDialogWithAPIError(e);
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (window.isValidating || !device.valid) {
      return;
    }
    handleSubmitCore();
  }

  return (
      <ScannedDeviceSection>
        <TopSectionTitle>Add more devices</TopSectionTitle>
        <ScannedDeviceBlock>
          <ScannedDeviceBlockTitle>Scanned device</ScannedDeviceBlockTitle>
          <RegisteredDeviceDataArea>
            <RegisteredDeviceImageArea
                style={{
                  backgroundImage: `url(${device.image_url})`,
                }}
            />
            <RegisteredDeviceInfoArea>
              <RegisteredDeviceInfo>
                <h4>Device model</h4>
                <span>{device.device_name}</span>
              </RegisteredDeviceInfo>
              <RegisteredDeviceInfo>
                <h4>KUVO Device ID</h4>
                <span>{device.customer_id}</span>
              </RegisteredDeviceInfo>
              <RegisteredDeviceInfo>
                <h4>Serial no.</h4>
                <span>{device.serial_code || '- - - - - - - - - -'}</span>
              </RegisteredDeviceInfo>
            </RegisteredDeviceInfoArea>
          </RegisteredDeviceDataArea>


          <InputLabel>Room/Floor</InputLabel>
          <RegisteredDevieRoomDropdownWrap>
            <SelectedLabel onClick={onClickDropdown}>{r.name}</SelectedLabel>
            <SelectModal
                title="Room/Floor"
                candidates={rooms.map((c) => c.name)}
                selectedIndex={selectedIndex}
                closeModal={closeModal}
                modalIsOpen={modalIsOpen}
                itemSelect={itemSelect}
            />
          </RegisteredDevieRoomDropdownWrap>
          <RegisteredDevieRoomEditToggle
              onClick={() => {
                setEditIsOpen(!editIsOpen);
              }}
              className={editIsOpen
                  ? 'open new room-edit-toggle'
                  : 'closed new room-edit-toggle'}
          >
            Add another room/floor
          </RegisteredDevieRoomEditToggle>
          <RegisteredDevieRoomEditContent
              className={editIsOpen ? 'open new' : 'closed new'}
          >
            <form onSubmit={handleRoomAddSubmit}>
              <RegisteredDevieRoomEditItem>
                <FormInput type="text" required name="name"/>
                <RegisteredDevieRoomAddButton
                    type="submit"
                    className="dark-button"
                >
                  <span>Add</span>
                </RegisteredDevieRoomAddButton>
              </RegisteredDevieRoomEditItem>
            </form>
          </RegisteredDevieRoomEditContent>
          <form onSubmit={handleSubmit}>
            <ScannedDeviceRegisterButton
                className={`dark-button center-fixed ${
                    device.valid ? '' : 'disabled'
                }`}
                disabled={!device.valid}
                type="submit"
            >
              <span>Register</span>
            </ScannedDeviceRegisterButton>
          </form>
        </ScannedDeviceBlock>
      </ScannedDeviceSection>
  );
}

function RegisteredDevice({device}) {
  const auth = useAuth();
  const [editIsOpen, setEditIsOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [roomID, setRoomID] = useState(device.room_id);
  const {customDialog, errorDialogWithAPIError, okDialog} = useCustomDialog();
  const rooms = auth.state.rooms || [];
  const [serialCode, setSerialCode] = useState(device.serial_code);
  const serialInputRef = useRef();

  useEffect(() => {
    setSerialCode(device.serial_code);
  }, [device.serial_code]);

  const onRemoveClick = (event) => {
    event.preventDefault();
    (async () => {
      let confirm = await customDialog({
        description_element: (
            <>
              Are you sure you
              <br className={'sp'}/>{' '}
              want to remove
              <br/>
              {device.customer_id}
              <br/>
              from your account?
            </>
        ),
        closable: true,
        buttons: [
          {
            label: 'No, cancel',
            positive: false,
          },
          {
            label: 'OK',
            positive: true,
          },
        ],
      });
      if (confirm != 1) {
        return;
      }
      window.incrementLoading();
      try {
        let devices = await deleteDevice({
          device_id: device.device_id,
        });
        console.log(devices);
        auth.dispatch({
          type: 'set_devices',
          devices,
        });
        window.decrementLoading();
      } catch (e) {
        window.decrementLoading();
        console.error(e);
        await errorDialogWithAPIError(e);
      }
    })();
  };

  let selectedIndex = -1;
  let r = rooms.find((_r, i) => {
    if (_r.room_id == roomID) {
      selectedIndex = i;
      return true;
    }
    return false;
  });
  if (selectedIndex < 0) {
    selectedIndex = 0;
    r = rooms[0];
  }

  const onClickDropdown = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const itemSelect = (index) => {
    setModalIsOpen(false);
    setRoomID(rooms[index].room_id);
  };

  const isValidSerialCode = (code) => {
    return !code || /^[0-9a-z]{12}$/i.test(code);
  };

  const validateSerialCode = (event) => {
    let value = event.target.value.trim().toUpperCase();
    if (serialCode == value) {
      return;
    }
    setSerialCode(value);
  };

  const onChangeSerialCodeClick = (event) => {
    event.preventDefault();

    if (!isValidSerialCode(serialCode)) {
      return;
    }

    (async () => {
      window.incrementLoading();
      try {
        let {devices} = await changeDeviceSerialCode({
          device_id: device.device_id,
          serial_code: serialCode.toUpperCase(),
        });
        auth.dispatch({
          type: 'set_devices',
          devices,
        });
        window.decrementLoading();
        setSerialCode(serialCode.toUpperCase());
        if (serialInputRef.current) {
          serialInputRef.current.value = serialCode.toUpperCase();
        }
        await okDialog({
          description_element:
              <span>Serial number has been saved successfully.</span>,
        });
      } catch (e) {
        window.decrementLoading();
        console.error(e);
        await errorDialogWithAPIError(e);
      }
    })();

  };

  const onChangeButtonClick = (event) => {
    event.preventDefault();

    (async () => {
      window.incrementLoading();
      try {
        let {devices} = await changeDeviceRoom({
          device_id: device.device_id,
          room_id: roomID,
        });
        auth.dispatch({
          type: 'set_devices',
          devices,
        });
        window.decrementLoading();
        await okDialog({
          description_element: <span>The room/floor has been updated.</span>,
        });
      } catch (e) {
        window.decrementLoading();
        console.error(e);
        await errorDialogWithAPIError(e);
      }
    })();
  };

  const handleRoomAddSubmit = (event) => {
    event.preventDefault();
    let form = event.currentTarget;
    let formData = new FormData(form);
    let name = (formData.get('name') || '').trim().substr(0, 256);
    if (!name) {
      (async function() {
        await customDialog({
          buttons: ButtonLayout.None,
          description_element: (
              <ul>
                <li>- Room/floor is required</li>
              </ul>
          ),
        });
      })();
      return;
    }
    if (rooms.some((r) => r.name.toUpperCase() == name.toUpperCase())) {
      (async function() {
        await customDialog({
          buttons: ButtonLayout.None,
          description_element: (
              <ul>
                <li>- The floor/room name already exists.</li>
              </ul>
          ),
        });
      })();
      return;
    }

    (async () => {
      window.incrementLoading();
      try {
        let {room, rooms} = await addNewRoom({
          name,
        });
        /*
        {
          "room": {
            "room_id": 30,
            "name": "LOUNGE5"
          },
          "rooms": [
            {
              "room_id": 15,
              "name": "LOUNGE2"
            },
            :
        */
        form.reset();
        setRoomID(room.room_id);
        auth.dispatch({
          type: 'set_rooms',
          rooms,
        });

        window.decrementLoading();
      } catch (e) {
        window.decrementLoading();
        console.error(e);
        await errorDialogWithAPIError(e);
      }
    })();
  };

  //device.device_name = 'DJ Monitor GO - Club';

  return (
      <RegisteredDeviceBlock>
        {
          /Monitor/i.test(device.device_name) ? '' : (
              <RemoveDeviceButton className="light-button"
                                  onClick={onRemoveClick}>
                <span>Remove</span>
              </RemoveDeviceButton>
          )
        }
        <AddedOnLabel>
          Registered on&nbsp;&nbsp;&nbsp;
          {moment(device.associate_datetime).format('YYYY/MM/DD')}
        </AddedOnLabel>
        <RegisteredDeviceDataArea>
          <RegisteredDeviceImageArea
              style={{
                backgroundImage: `url(${device.image_url})`,
              }}
          />
          <RegisteredDeviceInfoArea>
            <RegisteredDeviceInfo>
              <h4>Device model</h4>
              <span>{device.device_name}</span>
            </RegisteredDeviceInfo>
            <RegisteredDeviceInfo>
              <h4>KUVO Device ID</h4>
              <span>{device.customer_id}</span>
            </RegisteredDeviceInfo>
            <RegisteredDeviceInfo>
              <h4>Serial no.</h4>
              <span>{device.serial_code || '- - - - - - - - - -'}</span>
            </RegisteredDeviceInfo>
          </RegisteredDeviceInfoArea>
        </RegisteredDeviceDataArea>

        {
          /Monitor/i.test(device.device_name) ? (
              <></>
          ) : (
              <>
                <InputLabel
                    style={{
                      marginTop: 20,
                    }}
                >Serial no.</InputLabel>

                <RegisteredDevieRoomDropdownWrap>
                  <FormInput
                      type="text"
                      name="serial_code"
                      defaultValue={serialCode}
                      maxLength={12}
                      pattern={'^[0-9a-zA-Z]{12}$'}
                      onBlur={validateSerialCode}
                      onChange={validateSerialCode}
                      ref={serialInputRef}
                  />
                  <RegisteredDeviceChangeButton
                      className="dark-button"
                      onClick={onChangeSerialCodeClick}
                      disabled={!isValidSerialCode(serialCode)}
                  >
                    <span>Save</span>
                  </RegisteredDeviceChangeButton>
                </RegisteredDevieRoomDropdownWrap>
                <InputLabel>Room/Floor</InputLabel>
                <RegisteredDevieRoomDropdownWrap>
                  <SelectedLabel
                      onClick={onClickDropdown}>{r.name}</SelectedLabel>
                  <RegisteredDeviceChangeButton
                      className="dark-button"
                      onClick={onChangeButtonClick}
                  >
                    <span>Change</span>
                  </RegisteredDeviceChangeButton>
                  <SelectModal
                      title="Room/Floor"
                      candidates={rooms.map((c) => c.name)}
                      selectedIndex={selectedIndex}
                      closeModal={closeModal}
                      modalIsOpen={modalIsOpen}
                      itemSelect={itemSelect}
                  />
                </RegisteredDevieRoomDropdownWrap>
                <RegisteredDevieRoomEditToggle
                    onClick={() => {
                      setEditIsOpen(!editIsOpen);
                    }}
                    className={editIsOpen
                        ? 'open room-edit-toggle'
                        : 'closed room-edit-toggle'}
                >
                  Add another room/floor
                </RegisteredDevieRoomEditToggle>
                <RegisteredDevieRoomEditContent
                    className={editIsOpen ? 'open' : 'closed'}
                >
                  <form onSubmit={handleRoomAddSubmit}>
                    <RegisteredDevieRoomEditItem>
                      <FormInput type="text" required name="name"/>
                      <RegisteredDevieRoomAddButton type="submit"
                                                    className="dark-button">
                        <span>Add</span>
                      </RegisteredDevieRoomAddButton>
                    </RegisteredDevieRoomEditItem>
                  </form>
                </RegisteredDevieRoomEditContent>

                <KUVOCareInfo device={device}/>
              </>
          )
        }
      </RegisteredDeviceBlock>
  );
}

function KUVOCareInfo({device}) {
  const {alertDialog} = useCustomDialog();
  const navigate = useNavigate();

  if (!device.care || !device.care.is_target_country) {
    return (<KUVOCareArea>
      <LabelWithInfo
          text={'KUVO Care'}
          labelclassname="care-label"
          style={{}}
          inline={false}
      >
        <div>
          KUVO Care is an extended warranty service currently available in the
          UK, France, Netherlands, Denmark, and Australia. KUVO Care is
          currently eligible only with CDJ-3000 and CDJ-3000X. Stay tuned for
          additional
          regions. <Link to={'/care/about/'}>Learn more</Link>
        </div>
      </LabelWithInfo>

      <button className={'dark-button'} disabled={true}>
        <span>Request for repair</span>
      </button>
    </KUVOCareArea>);
  }

  if (!device.care.status) {
    return (<KUVOCareArea>
      <LabelWithInfo
          text={'KUVO Care'}
          labelclassname="care-label"
          style={{}}
          inline={false}
      >
        <div>
          KUVO Care is an extended
          warranty service for KUVO
          partner venues. KUVO
          Care is available in your
          region. KUVO Care is currently eligible only with CDJ-3000 and
          CDJ-3000X.<br/> <Link
            to={'/care/about/'}>Learn more</Link> about
          how to qualify your
          device.
        </div>
      </LabelWithInfo>

      <button className={'dark-button'} disabled={true}>
        <span>Request for repair</span>
      </button>
    </KUVOCareArea>);
  }

  const onClick = () => {
    if (!device.serial_code) {
      return alertDialog({
        description_element: (
            <span>Serial No. is required to use the service. Please go back and register the serial no.</span>
        ),
      });
    }

    navigate(`/care/apply/${device.customer_id}/`);
  };

  return (<KUVOCareArea>
    <LabelWithInfo
        text={'KUVO Care'}
        labelclassname="care-label"
        style={{}}
        inline={false}
    >
      <div>
        KUVO is an extended warranty service for KUVO partner venues. KUVO Care
        is currently eligible only with CDJ-3000 and CDJ-3000X. Your device is
        eligible for
        KUVO Care. <Link to={'/care/about/'}>Read more</Link>
      </div>
    </LabelWithInfo>

    <button className={'dark-button'} onClick={onClick}>
      <span>Request for repair</span>
    </button>
  </KUVOCareArea>);
}

export default function DevicesPage() {
  const app = useApp();
  const auth = useAuth();
  const location = useLocation();
  const [checkedParam, setCheckedParam] = useState(false);
  const [newDevice, setNewDevice] = useState({
    customer_id: '',
    device_name: '',
    image_url: '',
    serial_code: '',
    scanned: false,
    valid: false,
    is_others: false,
    is_ours: false,
    room_id: auth.state.rooms.length ? auth.state.rooms[0].room_id : -1,
  });

  const navigate = useNavigate();

  useEffect(() => {
    app.showHeader();
    document.title = 'Venue Information';

    if (!checkedParam) {
      const searchParams = new URLSearchParams(window.location.search);
      let customer_id = searchParams.get('customer_id');
      let serial_code = searchParams.get('serial');
      if (!serial_code ||
          !/^[0-9a-z]{12}$/i.test(serial_code)
      ) {
        serial_code = '';
      } else {
        serial_code = serial_code.toUpperCase();
      }
      if (
          customer_id &&
          /^[0-9a-f]{15}$/i.test(customer_id) &&
          !newDevice.scanned
      ) {
        (async () => {
          window.incrementLoading();
          try {
            let device = await getScannedDeviceInfoWithAuth({
              customer_id: customer_id.toUpperCase(),
            });
            if (device && device.device_name) {
              let d = {
                ...device,
                scanned: true,
                valid: true,
                room_id: newDevice.room_id,
                serial_code,
              };
              console.log('Scanned device detected', d);
              setNewDevice(d);
            }
          } catch (e) {
            console.error(e);
          }
          setCheckedParam(true);
          window.decrementLoading();
        })();
      } else {
        setCheckedParam(true);
      }
    }
  }, []);

  useEffect(() => {
    if (auth.state.rooms.length && newDevice.room_id < 0) {
      setNewDevice({
        ...newDevice,
        room_id: auth.state.rooms[0].room_id,
      });
    }
  }, [auth.state.rooms]);

  if (!auth.state.rooms.length || !checkedParam) {
    return '';
  }
  return (
      <Page>
        <PageTopVenueName/>
        <SectionTitle>Setup</SectionTitle>
        <TabHeader
            buttons={[
              {
                title: 'Venue',
              },
              {
                title: 'Device',
              },
            ]}
            selectedIndex={1}
            onClickTab={() => {
              navigate(`/venue-info/${location.search || ''}`);
            }}
            style={{
              marginTop: 30,
            }}
        />

        <SubInner data-hash="new">
          {newDevice.scanned ? (
              <ScannedDevice device={newDevice} setDevice={setNewDevice}/>
          ) : (
              <NewDevice device={newDevice} setDevice={setNewDevice}/>
          )}
          <LabelWithInfo
              text={'Add a device from a QR code'}
              labelclassname="room-field-label"
              style={{
                marginBottom: 40,
                textAlign: 'center',
              }}
          >
            <div>Push ‘UTILITY’ button on the device.
              <br/>&gt; Select ‘KUVO’ tab in the utility menu.
            </div>
          </LabelWithInfo>
          <hr className="content-border"/>
          <RegisteredDevicesTitle>Registered Devices</RegisteredDevicesTitle>
          {auth.state.devices.map((device, i) => (
              <RegisteredDevice device={device} key={i}/>
          ))}
        </SubInner>
      </Page>
  );
}
